import fetch, { fetchJson, postJson } from 'utils/fetch';

export const update = (id, json) => {
  return fetch(`/pco-manager/aast/cases/interventions/${id}/generality.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(json, (key, value) => {
      return value === '' ? undefined : value;
    }),
  });
};

export const scheduleFromModal = (id, json) => {
  return postJson(
    `/pco-manager/planning/${id}/schedule`,
    JSON.stringify(json, (key, value) => {
      return value === '' ? undefined : value;
    })
  );
};

export const getSchedule = id => {
  return fetchJson(`/pco-manager/planning/${id}/schedule`);
};



// WEBPACK FOOTER //
// ./src/modules/saas/aast/interventions/api/index.js